// This regex is lenient and supports escaped quotes inside quoted values (e.g., \" inside ")
const NON_STANDARD_FILENAME_REGEX = /(filename\*?)\s*=\s*(?:"((?:[^"\\]|\\.)*)"|([^;,]+))/gi;

// Our original filename extraction did not follow RFC 5987 / 6266. It's unclear
// why. In order to maintain compatibility with that original implementation, we
// provide this more lenient (non-standard compliant) approach. Here we look for
// for filename parameter with quoted value that may contain semicolons
export function parseContentDispositionParametersNonstandard(
    header: string,
): Record<string, string> {
    const parameters: Record<string, string> = {};

    NON_STANDARD_FILENAME_REGEX.lastIndex = 0;

    for (
        let match = NON_STANDARD_FILENAME_REGEX.exec(header);
        match !== null;
        match = NON_STANDARD_FILENAME_REGEX.exec(header)
    ) {
        const [, paramName, quotedValue, unquotedValue] = match;
        const value = quotedValue || unquotedValue;
        const [filenameSegment] = value.split(';');
        const unescaped = filenameSegment?.trim().replace(/\\(.)/g, '$1');
        if (unescaped) {
            parameters[paramName] = unescaped;
        }
    }

    return parameters;
}
